import React from "react";
import { ListBulletIcon, TagIcon, TrophyIcon } from "@heroicons/react/24/outline";

export default function AudienceHeaderIcon({ audience }) {
  if (audience.audience_type === "category") {
    if (audience.category_emoji) {
      return (
        <span className="text-base leading-none" aria-hidden>
          {audience.category_emoji}
        </span>
      );
    }
    return <TagIcon className="h-4 w-4 text-theme-text opacity-40" aria-hidden />;
  }
  if (audience.audience_type === "platform") {
    return <TrophyIcon className="h-4 w-4 text-theme-text opacity-40" aria-hidden />;
  }
  if (audience.audience_type === "manual") {
    return <ListBulletIcon className="h-4 w-4 text-theme-text opacity-50" aria-hidden />;
  }
  return null;
}
